// extracted by mini-css-extract-plugin
export var audioPlayer = "_pv-0";